import { render } from "./Article-page.vue?vue&type=template&id=36422cc8&scoped=true"
import script from "./Article-page.vue?vue&type=script&lang=js"
export * from "./Article-page.vue?vue&type=script&lang=js"

import "./Article-page.vue?vue&type=style&index=0&id=36422cc8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36422cc8"]])

export default __exports__